import { Component } from '@angular/core';
import { Router } from '@angular/router';


@Component({
  selector: 'hmb-denied',
  templateUrl: './denied.component.html'
})

export class DeniedComponent {
 
  constructor( private router: Router) {

  }

}

